<div class="flex flex-col sm:flex-row justify-between w-full items-center py-2 sm:py-4 sm:px-1 gap-2 sm:gap-1">
  <div
    class="order-last sm:order-first"
    [ngClass]="{
    'hidden sm:block': !(showErrorMessage()),
    'invisible sm:visible': !(showErrorMessage()),
  }"
  >
    @if (showErrorMessage()) {
      <div class="flex items-center gap-2 bg-white py-1 px-2 sm:py-2 rounded-full">
        <img src="assets/icons/error.png" class="w-[20px] h-[20px]">
        <div class="font-semibold rounded-full bg-white text-sm sm:text-base text-toyotaRed text-center sm:text-left">
          @if (willDenyCC && !willDenyCE) {
            <p>Es sind keine Kontaktanlässe freigegeben.</p>
          }
          @if (willDenyCE && !willDenyCC) {
            <p>Es sind keine Kontaktkanäle freigegeben.
          }
          @if (noPreferredDealerError || noPreferredDealerLexusError) {
            <p>Bitte wählen Sie einen bevorzugten Vertragspartner aus.</p>
          }
        </div>
      </div>
    }
  </div>

  <div class="order-first sm:order-last">
    @if (showSaveButtons) {
      <div class="flex justify-center sm:justify-start items-center gap-4 sm:gap-2">
        <button
          class="bg-white text-lightText text-sm sm:text-base font-semibold rounded-full py-1 px-2 sm:py-2 hover:bg-gray-100 hover:text-gray-600"
          (click)="cancel.emit()"
        >
          <span class="hidden sm:inline">Änderungen verwerfen</span>
          <span class="sm:hidden">Abbrechen</span>
        </button>

        <button
          class="text-white text-sm sm:text-base rounded-full py-1 px-2 sm:py-2 font-semibold disabled:bg-lighterText"
          [ngClass]="
            brand.isLexus()
              ? 'bg-lexusBlue hover:bg-lexusBlueDark'
              : 'bg-toyotaRed hover:bg-toyotaRedDark'
          "
          [disabled]="showErrorMessage()"
          (click)="save.emit()"
        >
          <span class="hidden sm:inline">Änderungen speichern</span>
          <span class="sm:hidden">Speichern</span>
        </button>
      </div>
    }
  </div>
</div>
